export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_29-8d1ac0b597179fac2134c4f64133fc63.jpg";